import { Elements } from '@stripe/react-stripe-js';
import { useLoadStripe } from '../../hooks/useLoadStripe';
import ListPaymentMethod from './ListPaymentMethod';

function PaymentMethods(props) {
  const { stripePromise } = useLoadStripe();

  return (
    <Elements stripe={stripePromise}>
      <ListPaymentMethod {...props} />
    </Elements>
  )
}

export default PaymentMethods;